import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import TermsAndConditions from "@/pages/TermsAndConditions";
import ApplyPage from "@/pages/ApplyPage";
import ComebackPage from "@/pages/ComebackPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/comeback" element={<ComebackPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
